import React, { useState, useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import { EbPageLoader } from '../../Common';
import { EASEBUZZ_PS_LOGO_WHITE } from '../../../constants';
import { Merchant } from '../../../models';
import { MerchantService } from '../../../services';
import { handleApiExceptions, goTo, alertify, getRedirectPath } from '../../../app_methods';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../redux/actions';
import { Text2 } from '../../../styles';
import './index.scss';


const MerchantLoginForm = (props) => {
    const { form } = props;
    const { getFieldDecorator } = form;
    const { validations } = Merchant;

    const [isLoading, setIsLoading] = useState(false);
    const [isReseting, setIsReseting] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const [logo, setLogo] = useState(EASEBUZZ_PS_LOGO_WHITE);
    const [theme, setTheme] = useState("#001529");
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);

    const sha512 = (password) => {
        return crypto.subtle.digest("SHA-512", new TextEncoder("utf-8").encode(password)).then(buf => {
            return Array.prototype.map.call(new Uint8Array(buf), x => (("00" + x.toString(16)).slice(-2))).join("");
        });
    }

    const getInfo = () => {
        MerchantService.get_public_info({ code: props.match.params.code }).then(response => {
            if (response.success) {
                setLogo(response.data.logo_url);
                setTheme(response.data.theme);
                setIsMounted(true);
            }
            else {
                handleApiExceptions("Something went wrong! Please try again.");
            }
        }).catch(error => {
            handleApiExceptions(error);
        });
    };

    const login = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            setIsLoading(true);
            sha512(values.password).then(encryptedPassword => {
                MerchantService.login({ code: props.match.params.code, email: values.email.trim(), password: encryptedPassword }).then(response => {
                    if (response.success) {
                        props.updateCurrentUser({ ...response.data.merchant, parent_code: props.match.params.code });
                        const url = getRedirectPath(response.data.merchant.user.permissions)
                        goTo(url, props.history);
                    }
                    else {
                        handleApiExceptions(response.data? response.data.message :"Invalid credentials! Please try again.");
                    }
                    setIsLoading(false);
                }).catch(error => {
                    handleApiExceptions(error);
                    setIsLoading(false);
                });
            });
        });
    };

    const resetPassword = (e) => {
        e.preventDefault();
        const email = form.getFieldValue("email");
        if (!email) {
            alertify("Oops!!!", "Please enter your registered Email ID.", "error");
            return;
        }
        setIsReseting(true);
        MerchantService.reset_password({ code: props.match.params.code, email: email }).then(response => {
            if (response.success) {
                alertify("Success", "Password reset link sent successfully.", "success");
            }
            else {
                handleApiExceptions(response.message);
            }
            setIsReseting(false);
        }).catch(error => {
            handleApiExceptions(error);
            setIsReseting(false);
        });
    };

    const renderLogin = () => {
        return (
            <div
                className="merchant-login-wrapper"
                style={{
                    backgroundColor: theme || "#001529",
                    width: "100%",
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <div
                    className="p-3"
                    style={{
                        paddingTop: 20,
                        backgroundColor: "#EEEEEE",
                        height: "51%",
                        width: 350,
                        borderRadius: 10,
                        boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.69)"
                    }}
                >
                    <div
                        style={{
                            margin: "auto",
                            width: 160,
                            height: "auto",
                            overflow: "hidden",
                            textAlign: "center",
                            maxHeight: 65
                        }}
                    >
                        <img
                            style={{
                                margin: "auto",
                                width: "auto",
                                maxWidth: "100%",
                                maxHeight: 65
                            }}
                            alt=""
                            src={logo || EASEBUZZ_PS_LOGO_WHITE}
                        />
                    </div>
                    <div
                        className="my-3"
                        style={{
                            textAlign: "center"
                        }
                        }>
                        <Text2>Merchant Login</Text2>
                    </div>
                    <Form onSubmit={login}>
                        <Form.Item className="mb-0">
                            {getFieldDecorator("email", {
                                rules: validations.email
                            })(<Input autoComplete='off' className="mb-1" placeholder="Email ID" />)}
                        </Form.Item>
                        <Form.Item className="mb-0">
                            {getFieldDecorator("password", {
                                rules: validations.password
                            })(<Input autoComplete='off' className="mb-1" type="password" placeholder="Password" />)}
                        </Form.Item>
                        <Button className="w-100 mt-3" type="primary" htmlType="submit" loading={isLoading}>Login</Button>
                        <div className="mt-1 d-flex justify-content-end"><Button className="px-0" type="link" onClick={resetPassword} loading={isReseting}>Forgot Password</Button></div>
                    </Form>
                </div>
            </div>
        )
    };

    useEffect(() => {
        getInfo();
    }, []);

    return (
        isMounted ? renderLogin() : <EbPageLoader />
    )
};

const MerchantLogin = Form.create()(MerchantLoginForm);

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(MerchantLogin);